module.exports = __webpack_public_path__ + "static/media/architect_man.4006eebf.jpg";